module.exports = __webpack_public_path__ + "static/media/dohnal.efde8365.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/dohnal.jpg
// module id = 549
// module chunks = 0